import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';
import AuthenticationGuard from '~/containers/auth/AuthenticationGuard';
import LoginPage from '~/containers/auth/LoginPage';
import LogoutPage from '~/containers/auth/LogoutPage';
import ErrorPage from '~/containers/errors/ErrorPage';
import RouteErrorBoundary from '~/containers/errors/RouteErrorBoundary';
import ViewerLayout from './layout';
import ProtectedRoute from './protected-route';
import Session from './session';
import Viewer from './viewer';
import DemoRoute from './demo-route';

const sentryCreateBrowserRouter =
    Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const router = sentryCreateBrowserRouter([
    {
        path: '/login',
        element: <LoginPage />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/logout',
        element: <LogoutPage />,
        errorElement: <RouteErrorBoundary />,
    },
    {
        path: '/',
        element: (
            <AuthenticationGuard>
                <ProtectedRoute>
                    <DemoRoute>
                        <ViewerLayout />
                    </DemoRoute>
                </ProtectedRoute>
            </AuthenticationGuard>
        ),
        errorElement: <RouteErrorBoundary />,
        children: [
            {
                path: '/',
                element: <Viewer />,
                errorElement: <RouteErrorBoundary />,
            },
            {
                path: '/session/:sessionId',
                element: <Session />,
                errorElement: <RouteErrorBoundary />,
            },
        ],
    },
    {
        path: '/access-denied',
        element: (
            <ErrorPage
                status={401}
                title={'You are not authorized to see this page.'}
            />
        ),
    },
]);

export default router;
